import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Heart, Phone, Mail, Clock, Star, Leaf, HandHeart, Users, Shield, BookOpen, ArrowRight, Menu, X } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import BlogSection from "@/components/BlogSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LandingPage = () => {
  const [adminSettings, setAdminSettings] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [settingsRes, testimonialsRes, blogRes] = await Promise.all([
        axios.get(`${API}/admin/settings`),
        axios.get(`${API}/testimonials`),
        axios.get(`${API}/blog/published`)
      ]);
      setAdminSettings(settingsRes.data);
      setTestimonials(testimonialsRes.data);
      setBlogPosts(blogRes.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F4]" data-testid="landing-page">
      <Navigation />
      <HeroSection adminSettings={adminSettings} />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection testimonials={testimonials} />
      <BlogSection blogPosts={blogPosts} />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
